export default __webpack_public_path__ + "static/media/download.87bbc839.svg";